import { ReactElement } from "react";
import { Redirect, Route, RouteProps } from "react-router";

interface Props extends RouteProps {
  component: any;
}

export default function PrivateRoute({
  component: Component,
  ...rest
}: Props): ReactElement {
  // const { currentUser } = useAuth();

  const currentUser = localStorage.getItem("user");

  return (
    <Route
      {...rest}
      render={(props) =>
        currentUser ? <Component {...props} /> : <Redirect to="/login" />
      }
    ></Route>
  );
}
